import request from '@/utils/request'

//查询试卷
export function SelectPaper(params) {
    return request({
        url: '/api/Exam/Load',
        method: 'get',
        params
    })
}

//删除试卷
export function DeletePaper(data) {
    return request({
        url: '/api/Exam/Delete',
        method: 'post',
        data
    })
}

//查询试卷题目
export function SelectPaperQuestion(params) {
    return request({
        url: '/api/Exam/GetOfficial',
        method: 'get',
        params
    })
}

//查询过程
export function GetExamProcess(params) {
    return request({
        url: '/api/ExamProcess/Get',
        method: 'get',
        params
    })
}

//监控进入考试
export function EnterPaper(data) {
    return request({
        url: '/api/ExamProcess/AddProcess',
        method: 'post',
        data
    })
}

//查询试卷详情
export function SelectPaperDetail(params) {
    return request({
        url: '/api/Exam/Get',
        method: 'get',
        params
    })
}

//查询考试
export function SelectExam(params) {
    return request({
        url: '/api/Exam/LoadQT',
        method: 'get',
        params
    })
}

//查询指定考试考试
export function SelectPointExam(params) {
    return request({
        url: '/api/Exam/Get',
        method: 'get',
        params
    })
}
export function GetDetail(params) {
    return request({
        url: '/api/Exam/GetDetail',
        method: 'get',
        params
    })
}

export function GetDetailLx(params) {
    return request({
        url: '/api/Exam/GetDetailLx',
        method: 'get',
        params
    })
}

//查询题目详情
export function SelectQuestion(params) {
    return request({
        url: '/api/ExamQuestion/Get',
        method: 'get',
        params
    })
}

//添加
export function addQuest(data) {
    return request({
        url: '/api/ExamWrong/Add',
        method: 'post',
        data
    })
}